import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight, Calendar, ChatCircle } from "@phosphor-icons/react";
import usePageMeta from "@/hooks/usePageMeta";

export default function CheckoutCancel() {
  usePageMeta(
    "Checkout Cancelled",
    "No worries — your card wasn't charged. Come back any time to book your Discovery Session."
  );

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 md:py-32 text-center" data-testid="checkout-cancel-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <div className="w-20 h-20 border border-white/20 rotate-45 mx-auto mb-8 flex items-center justify-center">
          <ChatCircle size={32} weight="duotone" className="text-white/60 -rotate-45" />
        </div>
        <span className="overline">// Checkout Cancelled</span>
        <h1 className="heading-display text-4xl md:text-5xl mt-3 mb-6">
          No worries — <span className="text-[#FFD700]">we're here when you're ready.</span>
        </h1>
        <p className="text-lg text-white/70 font-light leading-relaxed mb-8">
          Your card wasn't charged. Whenever the timing feels right, your Discovery Session is one click away.
        </p>

        <div className="surface-card p-6 md:p-8 text-left mb-10">
          <div className="overline mb-3">// A Friendly Note</div>
          <p className="text-white/80 font-light leading-relaxed mb-4">
            The Discovery Session is designed to be low-pressure. If you have any questions before you book —
            about what's included, whether it's right for you, or anything else — just reach out. We're happy to help.
          </p>
          <a
            href="mailto:hello@eigooinc.net"
            data-testid="cancel-contact-link"
            className="text-sm text-[#FFD700] hover:underline font-semibold inline-flex items-center gap-2"
          >
            hello@eigooinc.net <ArrowRight size={12} />
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link to="/" data-testid="cancel-home-btn" className="btn-gold px-8 py-4 text-xs inline-flex items-center gap-3">
            <ArrowLeft size={14} /> Return to Home
          </Link>
          <Link to="/#discovery" data-testid="cancel-book-again-btn" className="btn-ghost px-8 py-4 text-xs inline-flex items-center gap-3">
            <Calendar size={14} /> Book a Discovery Session
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
